module.exports = __webpack_public_path__ + "static/media/p2.b944871a.png";